import me from '../assets/me.png';
import Button from './Button';
import charcterProject from '../assets/IllustrationWork.png';
import phoneContact from '../assets/phoneContact.png';
import Section from "./Section";
import ButtonNext from './ButtonNext';

function IntroPage(){
    return(
        <div>
            <IntroAbout/>
            <IntroProjects/>
            <IntroContact/>
        </div>
    )
}

function IntroAbout(){
    return (
        <Section id="introAbout">
            <div className='d-section-center'>
            
                <img className="d-section-illustration" src={me} alt=""/>

                <div className="d-section-text">
                    <h1>Hi</h1>
                    <h3>I'm Thomas, a software developer from France</h3>
                    <p>I am currently studying for a master's degree in computer science</p>
                    <a href="/about">
                        <Button>About me</Button>
                    </a>
                </div>
            </div>
            <ButtonNext href="#introProjects" />
        </Section>
    );
}

function IntroProjects(){
    return (
        <Section id="introProjects" negate={1} >
            <div className='d-section-center'>
                <div className="d-section-text">
                    <h1>Projects</h1>
                    <h3>Here are some of my projects</h3>
                    <p>Let see what I did</p>
                    <a href="/projects">
                        <Button>Projects</Button>
                    </a>
                </div>
                <img className="d-section-illustration" src={charcterProject} alt=""/>
                </div>
                <a href="#introContact">
                <ButtonNext href="#introContact" />
            </a>
        </Section>
    );
}

function IntroContact(){
    return (
        <Section id="introContact">
            <div className='d-section-center'>
                <img className="d-section-illustration" src={phoneContact} alt=""/>

                <div className="d-section-text">
                    <h1>Contact</h1>
                    <h3>Feel free to contact me</h3>
                    <p>Please click on the button to see more</p>
                    <a href="/contact">
                        <Button>Contact</Button>
                    </a>
                </div>
                </div>
        </Section>
    );
}

export default IntroPage;